import type { Route } from "@angular/router";

import { checkIfLoggedInFn, pmoEntity } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { Constants } from "../../shared/constants/constants";
import { SynchronizationSchedulePageType } from "../../shared/constants/enums";
import { SynchronizationScheduleComponent } from "../sync/synchronization-schedule/synchronization-schedule";
import { wfMonitoringPageGuards, wfSubmenuPageGuards } from "./_guards";

export const WORKFLOWS_ROUTES: Route[] = [
  {
    path: "workflow",
    canActivate: [checkIfLoggedInFn],
    children: [
      {
        path: "",
        component: SubmenuComponent,
        canActivate: [checkIfLoggedInFn, ...wfSubmenuPageGuards],
        data: {
          title: "workflow.workflowconfiguration",
          breadcrumb: "workflow.workflowconfiguration",
        },
      },
      {
        path: "workflow-decision",
        component: SynchronizationScheduleComponent,
        canActivate: [checkIfLoggedInFn, pmoEntity],
        data: {
          title: "workflow_rejection_scheduler.title",
          breadcrumb: "workflow_rejection_scheduler.title",
          pageType: SynchronizationSchedulePageType.WORKFLOW_DECISION,
        },
      },
      {
        path: "workflow-monitoring",
        canActivate: [checkIfLoggedInFn, ...wfMonitoringPageGuards],
        data: {
          title: "breadcrumbs.wf_monitoring_module.list",
          breadcrumb: "breadcrumbs.wf_monitoring_module.list",
          tableConfList: Constants.MAIN_TABLE_LIST_CONF_KEY.WORKFLOW_MONITORING,
        },
        loadComponent: () =>
          import("./workflow-monitoring/workflow-monitoring").then((m) => m.WorkflowMonitoringComponent),
      },
      {
        path: "workflow-configuration",
        canActivate: [checkIfLoggedInFn],
        loadChildren: () => import("./workflow-configuration/workflow-configuration-routes"),
      },
      {
        path: "workflow-triggers",
        canActivate: [checkIfLoggedInFn, pmoEntity],
        loadChildren: () => import("./workflow-triggers/workflow-trigger-routes"),
      },
      {
        path: "workflow-by-pass",
        canActivate: [checkIfLoggedInFn, pmoEntity],
        loadChildren: () => import("./workflow-by-pass/workflow-by-pass-routes"),
      },
    ],
  },
];
